import { render, staticRenderFns } from "./ViewProgressDetails.vue?vue&type=template&id=02bf31e3&scoped=true"
import script from "./ViewProgressDetails.vue?vue&type=script&lang=js"
export * from "./ViewProgressDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewProgressDetails.vue?vue&type=style&index=0&id=02bf31e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bf31e3",
  null
  
)

export default component.exports